import TeamName from './TeamName';

export default TeamName;
